export enum PRODUCT {
  M3 = "M3",
  ADMIN_CONSOLE = "ADMIN_CONSOLE",
  SMILE = "SMILE",
  CREDIT_LINE = "CREDIT_LINE",
  CORE_APP_ONBOARDING = "CORE_APP_ONBOARDING",
  UNKNOWN = "UNKNOWN",
}

export const getProduct = (): PRODUCT => {
  const pathname = String(window.location.pathname);

  // New URL structure: /:country_code/:flow/*
  // Matches patterns like /mx/d2c/*, /mx/store/*, /mx/ecommerce/*, /mx/kiosk/*
  if (/^\/[a-z]{2}\/(store|d2c|ecommerce|kiosk)/i.test(pathname)) {
    return PRODUCT.M3;
  }

  // Legacy URL patterns
  if (pathname.includes("merchant3") || pathname.includes("d2c")) {
    return PRODUCT.M3;
  }

  if (pathname.includes("admin-console")) {
    return PRODUCT.ADMIN_CONSOLE;
  }

  if (pathname.includes("person-registration") || pathname.includes("/pr/")) {
    return PRODUCT.SMILE;
  }

  if (pathname.includes("creditline")) {
    return PRODUCT.CREDIT_LINE;
  }

  if (pathname.includes("core-app-onboarding")) {
    return PRODUCT.CORE_APP_ONBOARDING;
  }

  return PRODUCT.UNKNOWN;
};
